import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueMeta from "vue-meta";
import IconBase from "@/components/IconBase.vue";
import IconImbox from "@/components/icons/IconImbox.vue";
import IconFeed from "@/components/icons/IconFeed.vue";
import IconFiles from "@/components/icons/IconFiles.vue";
import IconContact from "@/components/icons/IconContact.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faFilePdf,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faGithub,
  faBehance,
  faLinkedin,
  faDribbble,
} from "@fortawesome/free-brands-svg-icons";

library.add(faUserSecret, faFilePdf, faLink);
library.add(faGithub, faBehance, faLinkedin, faDribbble);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("icon-base", IconBase);
Vue.component("icon-imbox", IconImbox);
Vue.component("icon-feed", IconFeed);
Vue.component("icon-files", IconFiles);
Vue.component("icon-contact", IconContact);

Vue.config.productionTip = false;
Vue.use(VueMeta, { refreshOnceOnNavigation: true });

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
